import { format } from "date-fns";
import type { Webhook } from "../../state/api.types";
import { DetailItem } from "../shared/DetailItem";

type WebhookSlideoutDetailsProps = {
  webhook: Webhook;
};

export const WebhookSlideoutDetails = ({
  webhook,
}: WebhookSlideoutDetailsProps) => {
  return (
    <div className="space-y-3xl">
      <DetailItem label="URL" value={webhook.url} actions={["copy"]} />
      <DetailItem
        label="Secret"
        value={webhook.has_secret ? "******" : "-"}
        actions={[]}
      />
      <DetailItem
        label="Created on"
        value={format(webhook.created_at, "PPP")}
        actions={[]}
      />
    </div>
  );
};
